import { render } from "./StatisticsPage.vue?vue&type=template&id=76c1cadc&scoped=true"
import script from "./StatisticsPage.vue?vue&type=script&lang=js"
export * from "./StatisticsPage.vue?vue&type=script&lang=js"

import "./StatisticsPage.vue?vue&type=style&index=0&id=76c1cadc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c1cadc"]])

export default __exports__